/* Lookbook section — colorway swatch interaction.
   Clicking a swatch swaps the card image to that variant's media,
   updates the colorway label, and re-tones the stage background. */

class LookbookCard extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('[data-lb-image]');
    this.stage = this.querySelector('.lb-card__stage');
    this.colorwayLabel = this.querySelector('[data-lb-colorway]');

    this.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-lb-swatch]');
      if (!swatch || !this.contains(swatch)) return;
      event.preventDefault();
      this.activate(swatch);
    });
  }

  activate(swatch) {
    this.querySelectorAll('[data-lb-swatch]').forEach((button) => {
      const isActive = button === swatch;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (this.colorwayLabel && swatch.dataset.lbName) {
      this.colorwayLabel.textContent = swatch.dataset.lbName;
    }

    if (this.image && swatch.dataset.lbSrc) {
      if (swatch.dataset.lbSrcset) {
        this.image.setAttribute('srcset', swatch.dataset.lbSrcset);
      } else {
        this.image.removeAttribute('srcset');
      }
      this.image.setAttribute('src', swatch.dataset.lbSrc);
      if (swatch.dataset.lbName && this.image.dataset.lbAlt) {
        this.image.setAttribute('alt', this.image.dataset.lbAlt + ' · ' + swatch.dataset.lbName);
      }
    }

    if (this.stage && swatch.dataset.lbHex) {
      this.stage.style.backgroundColor = swatch.dataset.lbHex;
    }
  }
}

if (!customElements.get('lookbook-card')) {
  customElements.define('lookbook-card', LookbookCard);
}
